import ProfileImage from "./ProfileImage";
import {
  useAzureStorage,
  StorageEndpoint,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  StorageEndpointType,
} from "../../hooks/useAzureStorage";

import "./ProfileImage.css";

export interface ContactProfile {
  contactId: string;
}

interface ProfileImageProps {
  profile: ContactProfile;
  onSelect?: (profile: ContactProfile) => void;
  cssClass?: string;
  animate?: boolean;
}

const ContactProfileImage: React.FC<ProfileImageProps> = ({
  profile,
  onSelect: _onSelect,
  cssClass,
  animate,
}) => {
  const imageFileName = `${profile.contactId}.jpg`;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { storageDetail, azureStorageLoaded } = useAzureStorage(
    StorageEndpoint.profile,
    profile.contactId ? imageFileName : "",
    true
  );

  return profile.contactId ? (
    <ProfileImage
      cssClass={cssClass}
      profile={{ url: storageDetail?.Url }}
      animate={animate}
    />
  ) : null;
};

export default ContactProfileImage;
